var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWalletIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4379 4.875C14.4379 4.15013 13.8503 3.5625 13.1254 3.5625H2.96289C2.44512 3.5625 2.02539 3.98223 2.02539 4.5M2.02539 4.5L2.02539 12.9375C2.02539 13.7659 2.69696 14.4375 3.52539 14.4375H14.4004C15.2288 14.4375 15.9004 13.7659 15.9004 12.9375V6.9375C15.9004 6.10907 15.2288 5.4375 14.4004 5.4375H2.96289C2.44512 5.4375 2.02539 5.01777 2.02539 4.5ZM12.9379 9.9375C12.9379 10.2482 12.6861 10.5 12.3754 10.5C12.0648 10.5 11.8129 10.2482 11.8129 9.9375C11.8129 9.62684 12.0648 9.375 12.3754 9.375C12.6861 9.375 12.9379 9.62684 12.9379 9.9375Z",
    stroke: "#FF7926",
    strokeWidth: 1.13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletIcon);
export default __webpack_public_path__ + "static/media/wallet-icon.1e3feadc304c62c700ae71243394ae9c.svg";
export { ForwardRef as ReactComponent };